/**
 * Quantos embriões uma doadora produziu — e para onde eles foram.
 *
 * AS QUATRO CONTAGENS SOMAM. Os estágios de D7 (BI/BL/BX/BN/BE) são o que vai
 * para a TE; o DT, a vitrificação e o descarte são embriões A MAIS, cada um
 * com sua própria quebra por estágio.
 *
 *   produzido = TE + DT + vitrificação + descarte
 *
 * JÁ FOI O CONTRÁRIO, E CUSTOU CARO. Os estágios eram lidos como o total, e o
 * congelamento como uma fatia deles: cada embrião vitrificado ocupava a vaga
 * de um embrião de TE. 41 embriões que estão no botijão nunca existiram como
 * linha no banco — 16 deles de uma doadora que congelou tudo e não mandou
 * nada para a transferência, caso em que o sistema não criava embrião algum.
 *
 * Mora aqui, e não dentro do FIVTab, porque três lugares precisam da mesma
 * conta — a tela, o PDF e o espelho `lab_quantity` que alimenta o faturamento
 * por embrião. Quando ela morava só na tela, o PDF deduzia o descarte por
 * subtração e chegava a outro número.
 */

const num = (v) => parseInt(v, 10) || 0;

const somar = (donor = {}, campos = []) =>
  campos.reduce((s, f) => s + num(donor[f.key ?? f]), 0);

/** Os embriões que seguem para a transferência. */
export const paraTE = (donor, camposDeEstagio) => somar(donor, camposDeEstagio);

/** Direct Transfer, sempre pela quebra por estágio. */
export const congeladosDT = (donor, camposDT) => somar(donor, camposDT);

/**
 * Vitrificados.
 *
 * A quebra por estágio manda. `dest_vitri` só vale quando a quebra está
 * zerada — o caso dos lançamentos feitos quando havia uma caixinha de
 * quantidade só, sem fase. Esses embriões existem e contam no produzido;
 * ficam com estágio nulo, porque a fase deles nunca foi anotada e inventar
 * uma seria pior do que deixar em branco.
 */
export const vitrificados = (donor = {}, camposVitri) => {
  const quebra = somar(donor, camposVitri);
  return quebra > 0 ? quebra : num(donor.dest_vitri);
};

/** Descarte AFIRMADO, nunca deduzido por subtração. */
export const descartados = (donor, camposDesc) => somar(donor, camposDesc);

/** O produzido de verdade: a soma dos quatro grupos. */
export const produzidoPelaDoadora = (donor, campos) =>
  paraTE(donor, campos.estagio)
  + congeladosDT(donor, campos.dt)
  + vitrificados(donor, campos.vitri)
  + descartados(donor, campos.desc);

/** O mesmo, para a sessão inteira. */
export const produzidoNaSessao = (donors = [], campos) =>
  donors.reduce((s, d) => s + produzidoPelaDoadora(d, campos), 0);

/**
 * Congelado sem estágio: lançamento antigo esperando a fase.
 *
 * Não é erro — o embrião está no botijão e conta no produzido. É só o que
 * ainda falta registrar, e a tela marca com asterisco.
 */
export const vitriSemEstagio = (donor = {}, camposVitri) =>
  somar(donor, camposVitri) === 0 && num(donor.dest_vitri) > 0;
